import React from 'react';
import { useTranslation } from 'react-i18next';
import { TFunction } from 'i18next';
import { Prize } from '../../interfaces/predictors';
import { useGetPrizes } from '../../hooks/getPrizes/getPrizes';
import './PrizePool.scss';
import GradientBorder from '../GradientBorder/GradientBorder';
import { usePredictorStore } from 'store/predictor/predictorStore';
import DisplayCurrencyOrPrizeSuffix from '../DisplayPrizeCurrencyOrSuffix/DisplayPrizeCurrencyOrSuffix';
import { getPrizeSuffixTranslationKey } from './PrizePool.functions';

interface PrizeRowProps {
  prize: Prize | undefined;
  prizeNumber: number;
  t: TFunction;
  numPicks: number;
}

const getPrizeRow = ({ prize, prizeNumber, t, numPicks }: PrizeRowProps) => {
  if (!prize) return null;

  const suffixTranslationKey = getPrizeSuffixTranslationKey({ prizeCode: prize?.prizeCode });

  return (
    <div key={`prize-pool-${prizeNumber}`} className={`prize-row prize-row--${numPicks - prizeNumber}-correct`}>
      <div className='prize-row__text'>{t(`${numPicks - prizeNumber}-correct`)}</div>
      <div className='prize-row__prize'>
        <DisplayCurrencyOrPrizeSuffix
          value={prize.prizeAmount}
          currency={prize.prizeCurrencyCode}
          prizeCode={prize.prizeCode}
          prizeMultiplier={prize.prizeMultiplier}
          suffix={suffixTranslationKey}
        />
      </div>
    </div>
  );
};

const PrizePool = () => {
  const { t } = useTranslation();
  const prizes = useGetPrizes();
  const filteredPrizes = prizes.filter(
    (value, index, self) =>
      index ===
      self.findIndex(
        (t) => t.prizeMinPosition === value.prizeMinPosition && t.prizeMaxPosition === value.prizeMaxPosition,
      ),
  );
  const predictor = usePredictorStore((s) => s.activePredictor);
  const numPicks = predictor?.events?.length ?? 6;
  return (
    <GradientBorder name={'prize-pool-border'}>
      <div className='prize-pool'>
        <div className='prize-pool__header'>{t('prize-pools-capitals')}</div>
        {filteredPrizes.map((prize, index) => getPrizeRow({ prize, prizeNumber: index, t, numPicks }))}
      </div>
    </GradientBorder>
  );
};

export default PrizePool;
